.badges {
  display: inline-flex;
  gap: 6px;
  width: fit-content;
}
